import { useQuery } from "@tanstack/react-query";
import { useAppSelector } from "../../../../redux/hooks";
import { apiClient } from "../../../../zodios/client";

export const useGetStorePageProducts = (
  storePageUrl?: string,
  options?: { enabled?: boolean; refetchInterval?: number },
) => {
  const marketPlace = useAppSelector((state) => state.marketPlace.marketPlace);

  return useQuery({
    queryKey: [{ entity: "storePageProducts", storePageUrl }],
    queryFn: async () =>
      await apiClient.getStorePageProducts({
        queries: { store_page_url: storePageUrl!, market_place: marketPlace },
      }),
    enabled: !!storePageUrl,
    select: (res) => res.products,
    ...options,
  });
};
